import chronology from './component/chronology'
import history from './component/history'
import n100th_IntersectionObserver from './component/100th_IntersectionObserver'
n100th_IntersectionObserver();
chronology();
history();

